/**
 * Logger utility for frontend application
 * Only logs in development mode to prevent exposing sensitive information in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, but sanitize in production
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, only log error messages without sensitive data
      const sanitized = args.map(arg => {
        if (typeof arg === 'object') {
          // Remove sensitive fields
          const { token, password, secret, ...safe } = arg;
          return safe;
        }
        return arg;
      });
      console.error(...sanitized);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

export default logger;

